import React from 'react'

export const ValidateCertificate = [
  {
    name: 'Validação de certificado',
    component: React.lazy(() => import('../../modules/public/ValidateCertificate')),
    path: '/validate_certificate/:enrollmentId',
    guards: [],
  },
]
